import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  pollyConfigList: {
    records: [],
    total: 0,
  },
};

const getters = {
  pollyConfigList: state => state.pollyConfigList.records,
};

export default {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};
